// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import "babel-polyfill";
import Vue from "vue";
import axios from "axios";
import App from "./App";
import router from "./router";
import Element from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import "element-ui/lib/theme-chalk/display.css";
import "./assets/js/highlight.js";
import "./assets/js/highlightjs-line-numbers.js";
import "./assets/js/highlight.js";
import "./assets/js/highlightjs-line-numbers.js";

Vue.use(Element);

Vue.prototype.$api = axios;
axios.defaults.timeout = 10000;
axios.defaults.baseURL = "/api";
// axios.defaults.baseURL = '/api'
axios.defaults.headers.post["Content-Type"] = "application/json";
axios.defaults.withCredentials = true;

Vue.config.productionTip = false;
Vue.prototype.$log = window.console.log;

// 修改 el-dialog 默认点击遮照为不关闭
Element.Dialog.props.closeOnClickModal.default = false;

// function async ss() {
//     await this.$api('x',{})
// }
/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  components: { App },
  template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js